import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {FaLinkedinIn, FaGithub} from 'react-icons/fa'
import { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_3fjfb17', 'template_ky1ucaz', form.current, 'user_641J0AWGxx4qcKi835yDq')

    e.target.reset()
  };

  return (
    <section id='contact'>
      {/* Floating Background Elements */}
      <div className="contact__floating-element"></div>
      <div className="contact__floating-element"></div>
      
      {/* Section Header */}
      <div className="contact__header">
        <span className="contact__badge">Get In Touch</span>
        <h2 className="contact__main-title">Contact Me</h2>
        <p className="contact__subtitle">
          Ready to start your next project? Let's discuss how we can bring your ideas to life.
        </p>
      </div>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5 className="email_text">almustaphasulaiman@yahoo.com</h5>
            <a href="mailto:almustaphasulaiman@yahoo.com" target="_blank" rel="noopener noreferrer">Send Email</a>
          </article>
          <article className="contact__option">
            <FaLinkedinIn className='contact__option-icon'/>
            <h4>LinkedIn</h4>
            <h5>Professional Network</h5>
            <a href="https://linkedin.com/in/almustapha-sulaiman" target="_blank" rel="noopener noreferrer">Connect</a>
          </article>
          <article className="contact__option">
            <FaGithub className='contact__option-icon'/>
            <h4>GitHub</h4>
            <h5>View My Code</h5>
            <a href="https://github.com/yourusername" target="_blank" rel="noopener noreferrer">Follow</a>
          </article>
        </div>
        {/* END OF CONTACT OPTIONS */}
        <form ref={form} onSubmit={sendEmail} className="contact__form">
          <div className="form__group">
            <input type="text" name='name' placeholder='Your Full Name' required />
          </div>
          <div className="form__group">
            <input type="email" name='email' placeholder='Your Email Address' required />
          </div>
          <div className="form__group">
            <textarea name="message" rows="7" placeholder='Tell me about your project...' required></textarea>
          </div>
          <button type='submit' className='btn btn-primary contact__submit'>
            Send Message
            <span className="btn__arrow">→</span>
          </button>
        </form>
      </div>
    </section>
  )
}

export default Contact